(function () {
  'use strict';

  var DISCOUNT_CODE = 'BUNDLE20';

  function applyDiscount() {
    return fetch('/discount/' + DISCOUNT_CODE, { method: 'GET', credentials: 'same-origin' }).catch(function() {});
  }

  function setCartAttribute(key, value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { [key]: value } })
    }).catch(function() {});
  }

  function getCheckedVariants() {
    return Array.from(document.querySelectorAll('[data-bundle-item]:checked')).map(function (cb) {
      return parseInt(cb.dataset.variantId, 10);
    });
  }

  function getMainVariantId() {
    var sel = document.querySelector('[name="id"]');
    if (sel && sel.value) return parseInt(sel.value, 10);
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) { var inp = form.querySelector('input[name="id"]'); if (inp && inp.value) return parseInt(inp.value, 10); }
    var wrap = document.getElementById('bwWrap');
    if (wrap && wrap.dataset.variantId) return parseInt(wrap.dataset.variantId, 10);
    return null;
  }

  async function addToCartAndCheckout() {
    var btn = document.getElementById('bwAtcBtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Bezig\u2026'; }

    var mainVariantId = getMainVariantId();
    var accessoireVariantIds = getCheckedVariants();

    if (!mainVariantId) {
      if (btn) { btn.disabled = false; btn.textContent = 'In winkelwagen'; }
      return;
    }

    var items = [{ id: mainVariantId, quantity: 1 }];
    accessoireVariantIds.forEach(function (id) {
      items.push({ id: id, quantity: 1, properties: { _bundel: 'bundle-widget' } });
    });

    try {
      // 1. Cart attribuut voor Shopify Flow tagging
      await setCartAttribute('qlokkie_bundel', 'bundle-widget');

      // 2. Producten toevoegen
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      var data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Fout ' + res.status);

      // 3. Kortingscode toepassen als er accessoires zijn
      if (accessoireVariantIds.length > 0) await applyDiscount();

      // 4. Naar checkout
      window.location.href = '/checkout';
    } catch (err) {
      if (btn) { btn.disabled = false; btn.textContent = err.message || 'Probeer opnieuw'; }
    }
  }

  function init() {
    var btn = document.getElementById('bwAtcBtn');
    if (btn) btn.addEventListener('click', addToCartAndCheckout);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
